import React from "react";

const ProductCard = ({ item }) => {
  return (
    <div className="flex flex-col items-center border-none outline-none">
      <div className="w-32 md:w-60 border p-8 rounded-xl shadow-lg hover:scale-105 transition-all duration-300">
        <img
          src={item?.image}
          alt=""
          className="rounded h-16 md:h-36 mx-auto mb-3"
        />
        <h1 className="hidden md:block text-lg font-bold text-gray-700 tracking-wider truncate">
          {item?.name}
        </h1>
        {/* <p className="text-lg text-gray-500 ">{item?.price} K</p> */}
      </div>
      <h1 className="block md:hidden text-sm mt-1 text-gray-700 font-semibold">{item?.name}</h1>
    </div>
  );
};

export default ProductCard;
